import { render, staticRenderFns } from "./OrderStatusBadge.vue?vue&type=template&id=1a6fea5e&"
import script from "./OrderStatusBadge.vue?vue&type=script&lang=js&"
export * from "./OrderStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports